import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { message } from 'antd'
import { bindActionCreators } from 'redux'
import { updateSiteConfigs } from 'actions/Site'
import { createPartner, updatePartner, fetchPartnerDetail } from 'actions/Partners'
import FormMitraView from 'components/pages/mitra/Form'
import history from 'utils/history'
import Helper from 'utils/Helper'

const mapStateToProps = () => ({})

const mapDispatchToProps = dispatch => ({
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchPartnerDetail: bindActionCreators(fetchPartnerDetail, dispatch),
  createPartner: bindActionCreators(createPartner, dispatch),
  updatePartner: bindActionCreators(updatePartner, dispatch),
})

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('isSubmit', 'setIsSubmit', false),
  withState('isEdit', 'setIsEdit', false),
  withState('content', 'setContent', ''),
  withState('imgFile', 'setImgFile', ''),
  withState('currentImg', 'setCurrentImg', ''),
  withState('data', 'setData', {}),
  withHandlers({
    getDetail: props => async (id) => {
      const { setData, setImgFile, setCurrentImg } = props

      try {
        const res = await props.fetchPartnerDetail(id)
        setData(res)
        setImgFile(res.logo_path)
        setCurrentImg(res.logo_path)
      } catch (err) {
        setData()
        setImgFile()
      }
    },
    handleUpload: props => (info) => {
      const isImage = Helper.checkingFile(info)
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (isImage && fileList.length > 0) {
        const base64 = Helper.getBase64(info.file, file => props.setImgFile(file))
        return base64
      }
      return false
    },
    handleSubmit: props => (values) => {
      let payload

      props.setIsSubmit(true)

      if (props.imgFile === props.currentImg) {
        payload = {
          ...values,
        }
        delete payload.logo_file
      } else {
        payload = {
          ...values,
          logo_file: props.imgFile,
        }
      }

      if (props.isEdit) {
        props.updatePartner(props.match.params.id, payload)
          .then(() => {
            message.success('Mitra sudah diperbarui')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/mitra')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      } else {
        props.createPartner(payload)
          .then(() => {
            message.success('Mitra sudah dibuat')
            props.setIsSubmit(false)
            props.setImgFile('')
            history.push('/mitra')
          })
          .catch((error) => {
            props.setIsSubmit(false)
          })
      }
    },
  }),
  lifecycle({
    componentDidMount() {
      const { match, setIsEdit, getDetail } = this.props
      this.props.updateSiteConfigs({
        titlePage: 'Social Media',
        activePage: 'social-media',
        activeSubPage: 'social-media',
      })
      if (match.params.id) {
        setIsEdit(true)
        getDetail(match.params.id)
      }
    },
  }),
)(FormMitraView)
